import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AppConstants } from 'src/app/core/constants';
import { ContactUsService } from 'src/app/core/services/contact.us.service';

@Component({
  selector: 'app-perfect-car',
  templateUrl: './perfect-car.component.html',
  styleUrls: ['./perfect-car.component.scss',],
})
export class PerfectCarComponent {

  callbackForm = new UntypedFormGroup({
    mobile: new UntypedFormControl('', [Validators.required, Validators.pattern(AppConstants.PHONE_PATTERN),]),
  });

  constructor(
    private _toastr: ToastrService,
    private _contactService: ContactUsService
  ) { }

  getCallback() {
    this.callbackForm.markAllAsTouched();
    if (this.callbackForm.invalid) return;

    this._contactService.contactUs({
      ...this.callbackForm.getRawValue(),
      source: 'RETAIL',
      query: 'Get callback',
    }).subscribe({
      next: ({ message, }) => {
        this._toastr.success(message);
        this.callbackForm.reset();
      },
    });
  }

}
